"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RadioMixin = require("../../mixins/components/RadioMixin");
var _FormControl = require("../FormControl/FormControl");
/**
 * A native ["radio" input](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio)
 * element. In general, you will want to use this with the `LabeledControl` component.
 *
 * @related ['FieldSet', 'LabeledControl']
 * @since 1.8.0
 */
var Radio = /*#__PURE__*/(0, _styledComponents.default)(_FormControl.FormControl).withConfig({
  displayName: "Radio",
  componentId: "c11n-8-107-0__sc-yicu80-0"
})(["", ""], _RadioMixin.RadioMixin);
exports.Radio = Radio;
Radio.displayName = 'Radio';
Radio.propTypes = {
  /**
   * @deprecated Use the native `id` attributed if you want to manually set the id, otherwise
   * let `LabeledControl` set this for you.
   */
  controlId: _propTypes.default.string,
  /**
   * Sets the checked state of the input and use as a
   * [controlled component](https://reactjs.org/docs/forms.html#controlled-components).
   */
  checked: _propTypes.default.bool,
  /**
   * Sets the checked state of the input and use as an
   * [uncontrolled component](https://reactjs.org/docs/uncontrolled-components.html).
   */
  defaultChecked: _propTypes.default.bool,
  /**
   * Mark the input as disabled. Can also be inherited from a LabeledControl or FieldSet parent.
   */
  disabled: _propTypes.default.bool,
  /**
   * The native `name` attribute used to link multiple inputs together.
   */
  name: _propTypes.default.string,
  /**
   * Marks the input as required with the native [`required`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/required)
   * attribute.
   * Can be controlled by `FormField` context.
   */
  required: _propTypes.default.bool,
  /**
   * The HTML input type.
   * @ignore
   */
  type: _propTypes.default.string
};
Radio.defaultProps = {
  type: 'radio'
};

/** @component */